import React, { useRef } from "react";
import { Camera, Loader2, X } from "lucide-react";
import { assetUrl } from "@/lib/api";
import { MAX_REVIEW_PHOTOS } from "@/hooks/usePhotoUploads";

export function PhotoUploader({ photos, onAdd, onRemove }) {
  const fileRef = useRef(null);
  return (
    <div>
      <label className="text-luxe text-[10px] text-ink">Add photos <span className="normal-case tracking-normal text-muted-foreground">(up to {MAX_REVIEW_PHOTOS})</span></label>
      <div className="mt-2 flex flex-wrap gap-3">
        {photos.map((p) => (
          <div key={p.key} className="relative h-20 w-20 overflow-hidden border border-border bg-cream" data-testid="review-form-photo">
            <img src={p.url ? assetUrl(p.url) : p.preview} alt="" className={`h-full w-full object-cover ${p.uploading ? "opacity-40" : ""}`} />
            {p.uploading ? (
              <Loader2 className="absolute inset-0 m-auto h-5 w-5 animate-spin text-gold" />
            ) : (
              <button type="button" onClick={() => onRemove(p.key)} aria-label="Remove photo" data-testid="review-form-photo-remove" className="absolute right-1 top-1 grid h-5 w-5 place-items-center rounded-full bg-ink/80 text-ivory hover:bg-gold">
                <X size={11} />
              </button>
            )}
          </div>
        ))}
        {photos.length < MAX_REVIEW_PHOTOS && (
          <button type="button" onClick={() => fileRef.current?.click()} data-testid="review-form-add-photo" className="grid h-20 w-20 place-items-center border border-dashed border-border text-muted-foreground transition-colors hover:border-gold hover:text-gold">
            <Camera size={20} strokeWidth={1.4} />
          </button>
        )}
        <input
          ref={fileRef}
          type="file"
          accept="image/jpeg,image/png,image/webp,image/gif"
          multiple
          onChange={(e) => { onAdd(e.target.files); e.target.value = ""; }}
          className="hidden"
          data-testid="review-form-photo-input"
        />
      </div>
    </div>
  );
}
